import React from 'react';
import { useRecoilValue } from 'recoil';

import isEmpty from 'lodash-es/isEmpty';

import { openWindow } from '@ecp/common/src/utils/utils';
import moTheme from '@ecp/common/src/style/theme/mo';
import { FlexBox, FlexBoxColumn } from '@ecp/common/src/layouts/flex/styled';
import { Spacing } from '@ecp/common/src/layouts/Spacing';
import Accordion from '@ecp/common/src/components/accordion/mo/Accordion';
import { TextButton } from '@ecp/common/src/components/button/mo/TextButton';

import { withMobileStatus } from '@mo-recoil/system/selector';
import useSiteInfo from '@mo-hooks/common/useSiteInfo';
import { Container, InfoTextBox } from '@ecp/mo/sites/skypass/styles/footer/SkypassFooterBusinessInfoStyles';

export default function SkypassFooterBusinessInfo() {
  const {
    systemInformation: { resdEmail, customerCenterTel },
  } = useSiteInfo();
  const { isMobileApp, agentType } = useRecoilValue(withMobileStatus);

  function onClickMailTo() {
    const emails = 'mailTo:' + resdEmail;
    window.location.href = emails;
  }

  return (
    <Container>
      <Accordion>
        <FlexBox width={'max-content'}>
          <Accordion.Control
            buttonPadding={'5px 0 0 0'}
            align-items={'center'}
            buttonAriaLabel={'삼성웰스토리 사업자 정보'}
          >
            <InfoTextBox size={moTheme.font.size.$13}>사업자 정보</InfoTextBox>
            <Spacing left={5} />
          </Accordion.Control>
        </FlexBox>
        <Accordion.Body>
          <FlexBoxColumn align-items={'flex-start'} padding={'10px 0 0 0'}>
            <FlexBoxColumn align-items={'flex-start'}>
              <InfoTextBox>(주) 대한항공 대표: 우기홍 외 1명</InfoTextBox>
              <Spacing top={3} />
              <InfoTextBox>주소: 서울특별시 강서구 하늘길 260</InfoTextBox>
              <Spacing top={3} />
              <InfoTextBox>전화: {customerCenterTel}</InfoTextBox>
              <Spacing top={3} />
              <InfoTextBox>
                이메일&nbsp;
                <TextButton
                  textProps={{
                    weight: moTheme.font.weight.medium,
                    size: moTheme.font.size.$12,
                    height: moTheme.font.lineHeight.demiLight,
                  }}
                  onClick={onClickMailTo}
                >
                  {' '}
                  {isEmpty(resdEmail) ? '' : resdEmail}
                </TextButton>
              </InfoTextBox>
              <Spacing top={3} />
              <InfoTextBox>호스팅 사업자 : 삼성SDS(주)</InfoTextBox>
            </FlexBoxColumn>
            <Spacing top={10} />
            <FlexBoxColumn align-items={'flex-start'}>
              <InfoTextBox>사업자등록번호 110-81-14794</InfoTextBox>
              <TextButton
                textProps={{
                  weight: moTheme.font.weight.medium,
                  size: moTheme.font.size.$12,
                  height: moTheme.font.lineHeight.demiLight,
                }}
                onClick={() => {
                  openWindow(isMobileApp, 'https://www.ftc.go.kr/www/bizContents.do?key=253', '_blank', agentType);
                }}
              >
                [사업자 확인]
              </TextButton>
              <InfoTextBox>통신판매업 신고번호(제 2006-16-3010호)</InfoTextBox>
              <InfoTextBox>개인정보보호책임자 : 최희정 상무</InfoTextBox>
            </FlexBoxColumn>
            <Spacing top={10} />
          </FlexBoxColumn>
        </Accordion.Body>
      </Accordion>
    </Container>
  );
}
